var Component = require("enyo/Component"),
    kind      = require("enyo/kind");

/**
 * This component serves as a proxy for running queries against a repository.
 *
 * @abstract
 */
module.exports = kind(/** @lends app.Domain.Ott.Api.V2.ProxyRepository.prototype */ {

    /**
     * @private
     */
    name: "app.Domain.Ott.Api.V2.ProxyRepository",

    /**
     * @private
     */
    kind: Component,

    /**
     * @type {app.Domain.Ott.Api.V2.Repository}
     * @private
     */
    repository: null,

    // API
    // --------------------------------

    /**
     * Clears all cached values
     *
     * @public
     */
    clearCache: function() {
        this.repository.clearCache();
    },

    /**
     * Always returns an empty request.
     *
     * @returns  {Object}  A Promise that resolves with the API response
     * @public
     */
    noop: function() {
        return Promise.resolve({
            status: null,
            data:   null
        });
    }

});
